import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { AddressAppProps } from "./address.js";
import React from "react";
export default class Allocations extends React.Component<AddressAppAllocationsProps, any>{
    private gridData = [];
    private gridOptions = {};
    private translations = {};
    private dataUrl: string;

    constructor(props) {
        super(props);
        this.dataUrl = "Address/InitAssignmentsView?id=" + encodeURIComponent(this.props.entity.AdrNr);
        this.gridOptions = this.props.context.allocationsGrid;
        this.translations = this.props.translations;
    }

    private getGridData() {
        HTTPService.get(this.dataUrl)
            .then(result => {
                this.gridData = result.Data.Zuordnungen;
                this.setState({});
            });
    }

    private addAllocation(allocationId) {
        HTTPService.post<JsonResultClass>('Address/AddAssignment', { adrNr: this.props.entity.AdrNr, assignment: allocationId })
            .then((result) => {
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(result.Message);
                    this.getGridData();
                } else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            });
    }

    private add = () => {
        const url = "DynamicSearch/Window/Address/?fullObject=true";

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.RowClicked, (dataItem) => {
            HTTPService.post<JsonResultClass>('Address/TestAssignment', { assignment: dataItem.adrnr })
                .then((result) => {
                    if (result.Code === 0) {
                        if (result.Data === true) {
                            DialogHelper.confirm(this.translations["Adresse.BereitsZugewiesen"]).then(isOk => {
                                if (isOk) {
                                    this.addAllocation(dataItem.adrnr);
                                }
                            });
                        } else {
                            this.addAllocation(dataItem.adrnr);
                        }
                    } else {
                        NotificationHelper.showErrorMessage(result.Message);
                    }
                });
        });
    }

    private edit = (dataItem: any) => {
        const url = 'Address/Edit?isWindow=true&id=' + encodeURIComponent(dataItem.AdrNr);

        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this.getGridData();
        });
    }

    private remove = (dataItem) => {
        DialogHelper.confirm(this.translations["Standard.Msg.Loeschen"]).then(isOk => {
            if (isOk) {
                HTTPService.post<JsonResultClass>('Address/DeleteAssignment', { assignment: dataItem.AdrNr })
                    .then((result) => {
                        if (result.Code === 0) {
                            NotificationHelper.showSuccessMessage(result.Message);
                            this.getGridData();
                        } else {
                            NotificationHelper.showErrorMessage(result.Message);
                        }
                    });
            }
        });
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this.add();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this.edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this.remove(dataItem);
        }
    }

    componentDidMount() {
        this.getGridData();
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this.translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this.translations["Standard.Editieren"], enabled: this.props.entity.RecordRight.CanWrite });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this.translations["Standard.Loeschen"], enabled: this.props.entity.RecordRight.CanWrite });

        const content = <Grid data={this.gridData} options={this.gridOptions} id="addressAllocations"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />

        return (content);
    }
}

interface AddressAppAllocationsProps extends AddressAppProps {
    translations: Array<string>;
}
